import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tariff-history.reducer';

export const TariffHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tariffHistoryEntity = useAppSelector(state => state.tariffHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tariffHistoryDetailsHeading">
          <Translate contentKey="crawlerBackendApp.tariffHistory.detail.title">TariffHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.id}</dd>
          <dt>
            <span id="tariff">
              <Translate contentKey="crawlerBackendApp.tariffHistory.tariff">Tariff</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.tariff}</dd>
          <dt>
            <span id="effectiveDate">
              <Translate contentKey="crawlerBackendApp.tariffHistory.effectiveDate">Effective Date</Translate>
            </span>
          </dt>
          <dd>
            {tariffHistoryEntity.effectiveDate ? (
              <TextFormat value={tariffHistoryEntity.effectiveDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="expirationDate">
              <Translate contentKey="crawlerBackendApp.tariffHistory.expirationDate">Expiration Date</Translate>
            </span>
          </dt>
          <dd>
            {tariffHistoryEntity.expirationDate ? (
              <TextFormat value={tariffHistoryEntity.expirationDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="supplierId">
              <Translate contentKey="crawlerBackendApp.tariffHistory.supplierId">Supplier Id</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.supplierId}</dd>
          <dt>
            <span id="contractType">
              <Translate contentKey="crawlerBackendApp.tariffHistory.contractType">Contract Type</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.contractType}</dd>
          <dt>
            <span id="variant">
              <Translate contentKey="crawlerBackendApp.tariffHistory.variant">Variant</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.variant}</dd>
          <dt>
            <span id="commercialBusiness">
              <Translate contentKey="crawlerBackendApp.tariffHistory.commercialBusiness">Commercial Business</Translate>
            </span>
          </dt>
          <dd>{tariffHistoryEntity.commercialBusiness}</dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.tariffHistory.tariffType">Tariff Type</Translate>
          </dt>
          <dd>{tariffHistoryEntity.tariffType ? tariffHistoryEntity.tariffType.type : ''}</dd>
        </dl>
        <Button tag={Link} to="/tariff-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tariff-history/${tariffHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TariffHistoryDetail;
